export default __webpack_public_path__ + "static/media/UME-Logo-Controller-bg.dccb6ead.png";